<template>
  <div id="owner_rpts_promotions_overdue_rpt">
    <CardedSectionHeader
      icon="mdi-form-map"
      label="Report Filter"
      id="owner_promotions_overdue_report_filter"
    ></CardedSectionHeader>
    <CardedForm
      ref="owner_promotions_overdue_report_filter_form_ref"
      id="owner_promotions_overdue_report_filter_form_form"
      title="You can filter by: Start date and End date "
      :is_loading="is_loading"
      @on-submit-form="filter_report"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      cmp_class="ma-0 pl-5 pr-5 pt-0 white"
      @on-clear-form="on_clear_form"
    >
      <v-row no-gutterss class="pa-0 mb-0" :key="date_input_key">
        <v-col class="pt-0 pb-0 mb-0">
          <DateField
            label="Start Date"
            v-model="form.start_date_display"
            :disabled="is_loading"
            :validation_rules="form_validations.start_date_display"
            :min="'2018-01-01'"
            :max="form.date_today"
          ></DateField>
        </v-col>
        <v-col class="pt-0 pb-0 mb-0">
          <DateField
            label="End Date"
            v-model="form.end_date_display"
            :disabled="is_loading"
            :validation_rules="form_validations.end_date_display"
            :min="form.start_date_display"
            :max="form.date_today"
          ></DateField>
        </v-col>
      </v-row>
    </CardedForm>
    <CardedSectionHeader
      icon="mdi-form-map"
      label="Report Table"
      id="owner_promotions_overdue_report_table"
    ></CardedSectionHeader>
    <CardedTable
      :items="items"
      :headers="headers"
      :show_search="true"
      :show_description="false"
      :show_header_bar="true"
      :has_margin="false"
    >
      <template v-slot:controls>
        <div>
          <h4 class="pt-3">{{ report_message }}</h4>
        </div>
      </template>

      <template v-slot:[`item.expiry`]="{ item }">
        <span class="red--text" v-if="item.expiry == 'overdue'"><b>Overdue</b></span>
      </template>
      <template v-slot:[`item.has_been_ended`]="{ item }">
        <span class="red--text" v-if="parseInt(item.has_been_ended) == 1"><b>Ended</b></span>
        <span class="green--text" v-if="parseInt(item.has_been_ended) == 0"><b>Active</b></span>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </CardedTable>
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedTable from "../../../components/CardedTable";
import CardedForm from "../../../components/CardedForm";
import DateField from "../../../components/DateField";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils"; 
export default {
  name: "OwnerReportsOverdue",
  components: {
    CardedSectionHeader,
    DateField,
    CardedTable,
    CardedForm
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
        return ServerClient.Login.get_logged_in_user();
      },
    },
  },
  data: () => {
    return {
      _user: null,
      errors: [],
      message: "",
      form: {
        start_date_display: Utils.get_today_date_str(),
        end_date_display: Utils.get_today_date_str(),
        date_today: Utils.get_today_date_str(),
        user_id: 0
      },
      form_validations: {
        start_date_display: [],
        end_date_display: [],
        date_today: [],
      },
      items: [],
      headers: [
        {
          text: "Title",
          align: "start",
          sortable: true,
          value: "title",
          filterable: true,
        },
        {
          text: "Business",
          align: "start",
          sortable: false,
          value: "business.name",
          filterable: true,
        },
        {
          text: "Starts",
          align: "center",
          sortable: true,
          value: "starts_on",
          filterable: true,
        },
        {
          text: "Ends",
          align: "center",
          sortable: true,
          value: "ends_on",
          filterable: true,
        },
        {
          text: "Expiry",
          align: "start",
          sortable: true,
          value: "expiry",
          filterable: true,
        },
        {
          text: "Status",
          align: "start",
          sortable: true,
          value: "has_been_ended",
          filterable: true,
        },
        { text: "", value: "actions", sortable: false, align: "end", },
      ],
      report_message: "",
      date_input_key: "overdue_promo_date_inputs_key_1",
      date_input_key_truck : 1,
    };
  },
  methods: {
    on_clear_form(){
      this.form.start_date_display =  Utils.get_today_date_str();
      this.form.end_date_display = Utils.get_today_date_str();
      this.form.date_today = Utils.get_today_date_str();
      this.form.user_id = this._user.id;
      this.date_input_key_truck = this.date_input_key_truck + 1;
      this.date_input_key = "overdue_promo_date_inputs_key_" + this.date_input_key_truck;
      
    },
    on_auto_fill() {
        this.refresh_table();
    },
    filter_report() {
        this.refresh_table();
    },
    load_items(filter_config) {
      this.$emit("on-show-loader");
      ServerClient.Reports.get_owners_overdue_promotions_report(
        {
          ...filter_config
        },
        (res) => {
          
          
          this.items = res;

          this.process_report_message();
          this.$emit("on-hide-loader");
          var options = {
            offset: 50,
            duration: 1000,
            easing: "easeInOutCubic",
          };
            this.$vuetify.goTo("#owner_promotions_overdue_report_table", options);
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.errors = errors;
          this.$refs.owner_promotions_overdue_report_filter_form_ref.show_error_dialog();
        }
      );
    },
    refresh_table() {
      this.errors = [];
      var start_time_str = this.form.start_date_display + " 00:30:00 AM ";
      var start_time = Utils.date_str_to_php_time(start_time_str);
      var end_time_str = this.form.end_date_display + " 11:30:00 PM ";
      var end_time = Utils.date_str_to_php_time(end_time_str);
      if (start_time == end_time) {
        this.errors.push("Start time cannot be equal to end time");
        this.$refs.owner_promotions_overdue_report_filter_form_ref.show_error_dialog();
        return false;
      }
      if (start_time > end_time) {
        this.errors.push("Start time cannot be greater than end time");
        this.$refs.owner_promotions_overdue_report_filter_form_ref.show_error_dialog();
        return false;
      }

      this.load_items({
          ...this.form,
      });
    },
    process_report_message() {
      var num_str = "";
      if (this.items.length == 0) {
        num_str = " were no overdue promotions ";
      } else if (this.items.length == 1) {
        num_str = " was only (1) one overdue promotion ";
      } else if (this.items.length > 1) {
        num_str = " were " + this.items.length + " overdue promotions ";
      }

      var start_word = Utils.date_str_to_words(
        this.form.start_date_display,
        true,
        "of"
      );
      var end_word = Utils.date_str_to_words(this.form.end_date_display, true, "of");
      var msg = "";
      if (this.form.start_date_display == this.form.end_date_display) {
        msg = "There " + num_str + " on the " + start_word;
      } else {
        msg =
          "There " +
          num_str +
          " between the " +
          start_word +
          " and the " +
          end_word;
      }
      this.report_message = msg;
    },
    on_view_item(item) {
      this.$router.push("/owner/promotions/list/view/" + item.id);
    },
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();
    this.form.user_id = this._user.id;
    //nyd
    //if is not admin please redirect this user to the login screen

    this.$emit("set-page-attributes", {
      title: "Overdue Promotions Report",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Reports",
          disabled: false,
          href: "/owner/reports",
        },
        {
          text: "Overdues Report",
          disabled: true,
          href: "/owner/reports/overdue",
        },
      ],
    });

    this.refresh_table();

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#owner_rpts_promotions_overdue_rpt", options);
  },
};
</script>

